<div class="button-wrapper">
    <button
            type="button"
            mat-raised-button
            [routerLink]="buttonRouterLink"
            [ngClass]="{ 'large-button': buttonSize === 'Large' }"
            [matTooltip]="toolTip"
            [color]="buttonConfig?.styles?.color ? undefined : buttonConfig?.themeColor ? buttonConfig.themeColor : 'primary'"
            [ngStyle]="buttonConfig?.styles ? buttonConfig.styles : null"
            [disabled]="disabled || loading"
            (click)="onSubmit()">
        <ng-content></ng-content>
        <mat-icon *ngIf="icon" [matTooltip]="iconToolTip">{{icon}}</mat-icon>
        <mat-icon *ngIf="secondIcon" [matTooltip]="secondIconToolTip">{{secondIcon}}</mat-icon>
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    </button>
    <div class="disabled-hint" *ngIf="disabled && disabledHint">{{disabledHint}}</div>
</div>
